import React from 'react'
import axios from 'axios'
import { apiURL } from 'src/consumer/services'

export async function getGoals() {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')
  const countryCode = localStorage.getItem('countryCode')
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/bc/goals?languageCode=${languageCode}&countryCode=${countryCode}&platform=web`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
